<template>
    <div id="audio-player-root" >
        <div >
            <audio
                style="display:none"
                ref="player"
                :id="playerid"
            >
                <source :src="url" type="audio/mpeg" />
            </audio>
        </div>
            
            <div class="welcome__play">
                <div class="welcome__play-content">
                    <div class="welcome__play-icon" @click="toggleAudio()" v-if="!isPlaying"></div>
                    <div class="welcome__play-icon welcome__play-icon--pause" @click="toggleAudio()" v-else></div>
                    <vue-range-slider ref="slider" v-model="value" :tooltip="null" :height="2" :dot-size="10"></vue-range-slider>
                </div>
            </div>
            
        </div>
</template>

<script>
import '@/plugins/vue-range-component/vue-range-slider.css'
import VueRangeSlider from '@/plugins/vue-range-component/vue-range-slider.esm.js'

export default {
    props: ["url", "playerid", "event", "event_m"],
    components: {
        VueRangeSlider,
    },
    data() {
        return {
            playbackTime: 0,
            audioDuration: 100,
            audioLoaded: false,
            isPlaying: false,
            value: 0,
        };
    },
    methods: {
        initSlider() {
            var audio = this.$refs.player;
            if (audio) {
                this.audioDuration = Math.round(audio.duration);
            }
        },
        convertTime(seconds){
                            const format = val => `0${Math.floor(val)}`.slice(-2);
                var minutes = (seconds % 3600) / 60;
                return [minutes, seconds % 60].map(format).join(":");
        },
        totalTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.duration;
                return this.convertTime(seconds);
            } else {
                return '00:00';
            }
        },
        elapsedTime() {
            var audio = this.$refs.player;
            if (audio) {
                var seconds = audio.currentTime;
                return this.convertTime(seconds);
            } else {
                return '00:00';
            }
        },
        playbackListener() {
            var audio = this.$refs.player;
            this.playbackTime = audio.currentTime;
            audio.addEventListener("ended", this.endListener);
            audio.addEventListener("pause", this.pauseListener);
        },
        pauseListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
        },
        endListener() {
            this.isPlaying = false;
            this.listenerActive = false;
            this.cleanupListeners();
        },
        cleanupListeners() {
            var audio = this.$refs.player;
            audio.removeEventListener("timeupdate", this.playbackListener);
            audio.removeEventListener("ended", this.endListener);
            audio.removeEventListener("pause", this.pauseListener);
            //console.log("All cleaned up!");
        },
        toggleAudio() {
            var audio = this.$refs.player;
            if (audio.paused) {
                audio.play();
                this.isPlaying = true;
                if (this.event && this.event_m) {
                    if (window.innerWidth > 960) {
                        this.$gtag.event('click', {event_category: 'link','event_label': this.event});
                    } else {
                        this.$gtag.event('click', {event_category: 'link','event_label': this.event_m});
                    }
                }
            } else {
                audio.pause();
                this.isPlaying = false;
            }
        },
    },
    mounted: function() {
      this.$nextTick(function() {
        
        var audio=this.$refs.player;
        audio.addEventListener(
          "loadedmetadata",
          function() {
            this.initSlider();
          }.bind(this)
        );
        audio.addEventListener(
          "canplay",
          function() {
            this.audioLoaded=true;
          }.bind(this)
        );
        this.$watch("isPlaying",function() {
          if(this.isPlaying) {
            var audio=this.$refs.player;
            this.initSlider();
            if(!this.listenerActive) {
              this.listenerActive=true;
              audio.addEventListener("timeupdate",this.playbackListener);
            }
          }
        });
        this.$watch("playbackTime",function() {
        var diff=Math.abs(this.playbackTime-this.$refs.player.currentTime);
          if(diff>0.01) {
            this.$refs.player.currentTime=this.playbackTime;
          }
        });
      });
    },
    watch: {
        playbackTime(value) {
            this.value = value/this.audioDuration*100;
        },
        value(value) {
            this.playbackTime = value*this.audioDuration/100;
        },
    }
};
</script>

<style>
.vue-range-slider.slider-component {
    width: 100% !important;
}
.vue-range-slider.slider-component .slider {
    background-color: rgba(0, 46, 86, 0.2);
}
.vue-range-slider.slider-component .slider .slider-dot .slider-dot-handle {
    background-color: #0D2B54;
    -webkit-transition: all 300ms;
    -moz-transition: all 300ms;
    -ms-transition: all 300ms;
    -o-transition: all 300ms;
    transition: all 300ms;
    box-shadow: 0px 0px 0px 2px rgba(163, 35, 139, 0);
    box-shadow: none;
}
.vue-range-slider.slider-component .slider .slider-process {
    background-color: #A3238B !important;
}
.vue-range-slider.slider-component .slider .slider-dot .slider-dot-handle:hover {
    box-shadow: 0px 0px 0px 2px rgba(163, 35, 139, 0.5);
}
/* Play/Pause Button */
.play-button{
    height: 45px
}
input[type="range"] {
    margin: auto;
    -webkit-appearance: none;
    position: relative;
    overflow: hidden;
    width: 100%;
    cursor: pointer;
    outline: none;
    border-radius: 0; /* iOS */
    background: transparent;
}
input[type="range"]:focus {
    outline: none;
}
::-webkit-slider-runnable-track {
    background: #fff;
}
/*
 * 1. Set to 0 width and remove border for a slider without a thumb
 */
::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 0; /* 1 */
    height: 40px;
    background: #fff;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    border: none; /* 2px solid #999; */
}
::-moz-range-track {
    height: 40px;
    background: #ddd;
}
::-moz-range-thumb {
    background: #fff;
    height: 40px;
    width: 0; /* 20px; */
    border: none; /* 3px solid #999; */
    border-radius: 0 !important;
    box-shadow: -100vw 0 0 100vw dodgerblue; 
    box-sizing: border-box;
}
::-ms-fill-lower {
    background: dodgerblue;
}
::-ms-thumb {
    background: #fff;
    border: 2px solid #999;
    height: 40px;
    width: 20px;
    box-sizing: border-box;
}
::-ms-ticks-after {
    display: none;
}
::-ms-ticks-before {
    display: none;
}
::-ms-track {
    background: #ddd;
    color: transparent;
    height: 40px;
    border: none;
}
::-ms-tooltip {
    display: none;
}
</style>